// ============================================================================
// FILE: src/modules/invoice/services/invoiceService.js
// UPDATED: 2025-12-04
// PURPOSE: API service for Invoice Management (JWT scope-based)
// ============================================================================

import axiosClient from "../../../api/axiosClient";

const BASE_URL = "/invoice-management";

const invoiceService = {

  //---------------------------------------------------------------------------
  // 1️⃣ Upload Invoice
  //   Backend reads tenant/location from JWT
  //---------------------------------------------------------------------------
  async uploadInvoice(formData) {
    try {
      const res = await axiosClient.post(`${BASE_URL}/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      // backend returns: { success: true, id }
      return {
        success: res.data?.success,
        id: res.data?.id,
        message: res.data?.message,
      };
    } catch (error) {
      console.error("Invoice Upload Error:", error);
      return { success: false, message: "Upload failed" };
    }
  },

  //---------------------------------------------------------------------------
  // 2️⃣ Get List of Invoices (JWT scoped)
  //---------------------------------------------------------------------------
  async getInvoices() {
    try {
      const res = await axiosClient.get(`${BASE_URL}/list`);
      return res.data;
    } catch (error) {
      console.error("Invoice List Error:", error);
      return { success: false, invoices: [] };
    }
  },

  //---------------------------------------------------------------------------
  // 3️⃣ Get Invoice Details
  //---------------------------------------------------------------------------
  async getInvoiceDetail(id) {
    try {
      const res = await axiosClient.get(`${BASE_URL}/view/${id}`);
      return res.data;
    } catch (error) {
      console.error("Invoice Detail Error:", error);
      return { success: false, data: null };
    }
  },
};

export default invoiceService;
